import { CreateTableInput } from 'aws-sdk/clients/dynamodb';

export const CONNECTION_TABLE_NAME = 'connection';

export const CONNECTION_TABLE_SCHEMA: CreateTableInput = {
  TableName: CONNECTION_TABLE_NAME,
  AttributeDefinitions: [
    { AttributeName: 'monitorId', AttributeType: 'S' },
    { AttributeName: 'connectionId', AttributeType: 'S' },
  ],
  KeySchema: [
    { AttributeName: 'monitorId', KeyType: 'HASH' },
    { AttributeName: 'connectionId', KeyType: 'RANGE' },
  ],
  ProvisionedThroughput: {
    ReadCapacityUnits: 1,
    WriteCapacityUnits: 1,
  },
};
